import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import EnvVar from './env-var';
import EnvVarDetail from './env-var-detail';
import EnvVarUpdate from './env-var-update';
import EnvVarDeleteDialog from './env-var-delete-dialog';

const EnvVarRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<EnvVar />} />
    <Route path="new" element={<EnvVarUpdate />} />
    <Route path=":id">
      <Route index element={<EnvVarDetail />} />
      <Route path="edit" element={<EnvVarUpdate />} />
      <Route path="delete" element={<EnvVarDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default EnvVarRoutes;
